var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselGifts2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 0v9.224l8.502 4.458.07-.039v4.185l-1.007.592v.518l.015 16.97-17.771 10.516L7.363 35.91 7.362 35H0V0h35z",
    id: "3ds61h04ca"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#3ds61h04ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h35v35H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1C9DB",
    d: "M24.807 29.422v17.005l17.773-10.52-.007-16.972z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFBD58",
    d: "M24.807 29.428v-.56l17.758-10.461v.562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C9DB",
    d: "M43.571 13.643v4.185L24.837 28.885v-4.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFBDD3",
    d: "M24.81 29.426v17.003L7.362 35.909l.007-16.972z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#667999",
    d: "m24.813 30.377.013-1.524-17.467-10.45-.01 1.786"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFBDD3",
    d: "M24.837 24.657v4.228L6.429 18.03l.125-4.004"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D6E5",
    d: "M24.848 24.78 6.571 14.075 24.218 3.57l19.31 10.125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4CD7D",
    d: "m14.008 18.407 2.508 1.558L34.89 9.181l-3.002-1.574"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4CD7D",
    d: "m13.84 18.463-.268 21.185 2.771 1.649.293-21.349-2.795-1.628M35.402 18.521l-2.744 1.705-18.099-10.94 2.728-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.045 13.921c-.204.277-.414.534-.628.777a14.254 14.254 0 0 0 2.646-2.111 13.316 13.316 0 0 0 2.018-2.788s.673-1.235.446-2.06c-.083-.299-.265-.49-.265-.49-.227-.238-.5-.29-.579-.305-.031-.006-.58-.096-.96.287-.092.094-1.058 4.508-2.68 6.69h.002z",
    fill: "#DBA84A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.179 6.92 2.532 1.614c.557-.737 1.133-1.173 1.467-1.31.227-.094.475-.196.774-.143.076.013.118.03.125.015.037-.07-.934-.649-1.68-1.045-.363-.194-.69-.35-1.141-.406-.164-.02-.3-.038-.485-.015-.737.086-1.303.675-1.562 1.203-.012.022-.019.04-.024.05",
    fill: "#FFF2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.733 8.414a15.164 15.164 0 0 0-1.36 2.767 15.533 15.533 0 0 0-.838 3.366 9.593 9.593 0 0 1-.105-.246c-.699-1.684-.767-3.11-.817-4.355 0 0-.053-1.331.194-2.203a3.886 3.886 0 0 1 .365-.85",
    fill: "#FBD98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.43 14.448a6.894 6.894 0 0 0-.308-1.778 7.452 7.452 0 0 0-.483-1.18c-.286-.561-.46-.905-.824-1.281a3.432 3.432 0 0 0-.884-.666 3.388 3.388 0 0 0-1.386-.368 3.441 3.441 0 0 0-1.99.523l2.099 1.661",
    fill: "#FFF2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.525 9.726a3.54 3.54 0 0 0-.667.957 3.732 3.732 0 0 0-.34 1.278c-.038.366-.073.712.049 1.116.129.43.36.687.663 1.025.64.709 1.276.983 1.884 1.244.355.153.436.153.49.111.234-.186-.328-1.024-.348-2.387-.002-.143-.008-.28.012-.447.067-.553.306-.97.481-1.219l-2.187-1.723",
    fill: "#FBD98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.424 14.452a4.984 4.984 0 0 0-1.28-2.335c-.59-.596-.931-.822-1.24-.899-.183-.047-.627-.16-1.059.087a1.288 1.288 0 0 0-.529.605 1.394 1.394 0 0 0-.03.983l1.842 1.09 2.296.469z",
    fill: "#F9CC73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.338 14.504c-.329.352-1.969 2.16-1.998 4.495-.017 1.314.475 2.648.52 2.763.17.45.352.808.492 1.06l2.628-1.284a7.003 7.003 0 0 1-1.471-2.511c-.702-2.132-.157-3.987.066-4.634",
    fill: "#FBD98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.484 11.754a2.29 2.29 0 0 0-.472.607c-.217.406-.252.77-.274 1.034-.032.37-.067.769.136 1.205.06.128.212.442.553.666.328.216.652.229.964.238.267.008.606-.062 1.273-.205.837-.178 1.172-.283 1.54-.477a3.77 3.77 0 0 0 .294-.171 7.06 7.06 0 0 1-2.306-.203c-.084-.023-.785-.214-1.223-.632a1.494 1.494 0 0 1-.369-.519 1.39 1.39 0 0 1-.094-.351",
    fill: "#DBA84A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBD98B",
    d: "m24.439 14.67 11.568-2.452.09 2.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97A2B7",
    d: "m24.826 30.377-.01-1.526 17.736-10.444.013 1.795"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4CD7D",
    d: "m35.411 18.662.271 21.31-2.771 1.66-.295-21.455 2.795-1.658"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselGifts2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-gifts-2.2d2e3b3b1d7263f55b5a702642479476.svg";